(() => {
  const init = (section) => {
    const container = section.querySelector(".content-tabs");
    if (!container) return;

    const tabs = container.querySelectorAll(".tab");
    const contents = container.querySelectorAll("[data-content-index]");

    if (tabs.length === 0 || contents.length === 0) return;

    const activateTab = (index, shouldFocus = true) => {
      tabs.forEach((tab, i) => {
        const isActive = (i + 1).toString() === index;
        tab.classList.toggle("active", isActive);
        tab.setAttribute("aria-selected", isActive.toString());
        tab.setAttribute("tabindex", isActive ? "0" : "-1");
      });

      contents.forEach((content) => {
        const isActive = content.getAttribute("data-content-index") === index;
        content.classList.toggle("active", isActive);
        content.hidden = !isActive;
      });

      if (shouldFocus) {
        const activeTab = container.querySelector(
          `.tab[data-tab-index="${index}"]`
        );
        if (activeTab) {
          activeTab.focus();
        }
      }
    };

    tabs.forEach((tab) => {
      tab.addEventListener("click", () => {
        const index = tab.getAttribute("data-tab-index");
        activateTab(index);
      });

      tab.addEventListener("keydown", (e) => {
        const currentIndex = parseInt(tab.getAttribute("data-tab-index"));
        let newIndex = currentIndex;

        switch (e.key) {
          case "ArrowLeft":
            newIndex = currentIndex > 1 ? currentIndex - 1 : tabs.length;
            break;
          case "ArrowRight":
            newIndex = currentIndex < tabs.length ? currentIndex + 1 : 1;
            break;
          case "Home":
            newIndex = 1;
            break;
          case "End":
            newIndex = tabs.length;
            break;
          default:
            return;
        }

        e.preventDefault();
        activateTab(newIndex.toString(), true);
      });
    });

    activateTab("1", false);
  };

  const initContentTabsSection = () =>
    document.querySelectorAll(".section-content-tabs").forEach(init);

  document.readyState === "loading"
    ? document.addEventListener("DOMContentLoaded", initContentTabsSection)
    : initContentTabsSection();

  document.addEventListener("shopify:section:load", (e) =>
    initContentTabsSection(e.target)
  );
})();
